import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { destroy } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import moment from 'moment-timezone';
import Card from '../../../../components/card';
import { history } from './../../../../configuration/store';
import { getJobs, getJobWithClientInfo } from './../../../../reducers/jobs';
import { getAdminDetails } from '../../../../reducers/users';
import { getGreeting, getFullName } from './../../../../utilities/string';
import { renderProjectsValue } from './../../../../utilities/rate';
import DashboardAlerts from './../../components/alerts';
import messages from '../../../../text/messages';
import ContractorTimeKeeping from '../../../timekeeping/tenants/contractor/index';
import { getJobProjects } from '../../../../reducers/timekeeping';
import UnderReview from '../../components/underReview/index';
import { abbrDateYear } from '../../../../utilities/dateTime';

class ContractorDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.startOnboarding = this.startOnboarding.bind(this);
        this.renderAssignmentCard = this.renderAssignmentCard.bind(this);
    }

    componentDidMount() {
        const { getJobs, role, getJobWithClientInfo, getJobProjects, projects } = this.props;
        getJobs(role, jobs => {
            const job = jobs.length > 0 ? jobs[0] : undefined;
            if (job) {
                getJobWithClientInfo(job.id);
                getAdminDetails(job.contractor.admin_id);

                if (!projects) {
                    getJobProjects(job.id);
                }
            }
        });
    }

    startOnboarding(id) {
        this.props.destroy('contractor-onboarding-wizard');
        history.push(`/onboarding/${id}`);
    }

    renderAssignmentCard() {
        const { fullJobDetails, projects } = this.props;
        if (!fullJobDetails || !projects) return null;

        const { job, client, hiring_manager } = fullJobDetails;
        const { work_timezone, start_date, end_date, pay_type } = job;
        const { name } = client;

        const renderDate = (date, zone) => (date ? abbrDateYear(moment.tz(date, zone)) : '-');

        return (
            <div className="assignment-row">
                <div className="row">
                    <div className="col-xs-12 col-sm-4">
                        <div className="row assignment-cell">
                            <div className="col-xs-12 assignment-title">{name}</div>
                        </div>
                    </div>
                    <div className="col-xs-6 col-sm-4">
                        <div className="row assignment-cell">
                            <div className="col-xs-12 assignment-value ellipsis">{renderDate(start_date, work_timezone)}</div>
                            <div className="col-xs-12 assignment-subtitle">
                                <FormattedMessage {...messages.startDate} />
                            </div>
                        </div>
                        <div className="row assignment-cell">
                            <div className="col-xs-12 assignment-value ellipsis">{renderDate(end_date, work_timezone)}</div>
                            <div className="col-xs-12 assignment-subtitle">
                                <FormattedMessage {...messages.endDate} />
                            </div>
                        </div>
                    </div>

                    <div className="col-xs-6 col-sm-4">
                        <div className="row assignment-cell">
                            <div className="col-xs-12 assignment-value ellipsis">{getFullName(hiring_manager)}</div>
                            <div className="col-xs-12 assignment-subtitle">
                                <FormattedMessage {...messages.manager} />
                            </div>
                        </div>
                        <div className="row assignment-cell">
                            <div className="col-xs-12 assignment-value ellipsis">{renderProjectsValue(job, projects, true)}</div>
                            <div className="col-xs-12 assignment-subtitle">
                                <FormattedMessage {...(pay_type === 'h' ? messages.payRate : messages.contractValue)} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    getAssignmentLabel(status) {
        switch (status) {
            case 'active':
                return messages.currentAssignment;
            case 'inactive':
                return messages.completedAssignment;
            case 'pending':
                return messages.pendingAssignment;
            default:
                return messages.assignment;
        }
    }

    render() {
        const { user, fullJobDetails, admin } = this.props;
        const { job, client } = fullJobDetails || {};
        const { status, progress } = job || {};

        const assignmentLabel = this.getAssignmentLabel(status);

        const timekeeping = (
            <div className="timekeeping">
                <ContractorTimeKeeping {...this.props} dashboard={true} />
            </div>
        );

        return (
            <React.Fragment>
                <div className="row greeting">
                    <div className="col-xs-12 col-sm-8">
                        <span className="greeting-message">
                            {getGreeting()} {user.first_name}
                        </span>
                    </div>
                </div>
                <div className="row section">
                    <div className="col-md-8 col-xs-12">
                        {/* <HighPriorityAlerts /> */}
                        {admin &&
                            progress &&
                            (progress.branch === 'ic-continue-request' || progress.branch === 'dont-know' || progress.branch === 'dont-qualify-ic') && (
                                <div className="card-container">
                                    <UnderReview progress={progress} clientName={client && client.name} />
                                </div>
                            )}
                        {job && job.status === 'active' && <Card content={timekeeping} />}
                        <Card title={<FormattedMessage {...assignmentLabel} />} content={this.renderAssignmentCard()} />
                    </div>
                    <div className="col-xs-12 col-sm-4">
                        <DashboardAlerts />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

ContractorDashboard.defaultProps = {
    role: undefined,
    jobs: undefined
};
ContractorDashboard.propTypes = {
    role: PropTypes.object.isRequired,
    jobs: PropTypes.array
};

const mapStateToProps = state => {
    const jobs = state.jobs.list;
    const job = jobs && jobs.length > 0 ? jobs[0] : undefined;
    const jobDetails = state.jobs.withClientInfo;
    const fullJobDetails = job && jobDetails ? jobDetails[job.id] : undefined;

    return {
        fullJobDetails,
        user: state.identity.profile,
        projects: state.timekeeping.projects
        // admin: state.admins.adminDetails
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getJobProjects,
            getJobs,
            getJobWithClientInfo,
            destroy,
            getAdminDetails
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ContractorDashboard);



// WEBPACK FOOTER //
// ./src/pages/dashboard/tenants/contractor/index.jsx